/* global liveagent */

var liveAgentHost;
var buttonID;
var chatDeploymentID;
var chatOrganizationID;

/** Set chat global variables from the html attributes
 */
function setGlobalVariables() {
    const chatElement = document.querySelector('.js-chat');
    if (!chatElement) {
        return;
    }

    liveAgentHost = chatElement.dataset.liveagenthost;
    buttonID = chatElement.dataset.buttonid;
    chatDeploymentID = chatElement.dataset.deploymentid;
    chatOrganizationID = chatElement.dataset.organizationid;
}

/** Function used to set values into inputs
 */
function setValues() {
    liveagent.disconnect();
    liveagent.init(`${liveAgentHost}/chat`, chatDeploymentID, chatOrganizationID);
    liveagent.enableLogging();

    const idClienteValue = document.getElementById('idCliente').value;
    liveagent.addCustomDetail('Id cliente externo', idClienteValue).saveToTranscript('ADMS_Id_de_cliente_externo__c');

    const paisWebValue = document.getElementById('paisWeb').value;
    liveagent.addCustomDetail('Pais web', paisWebValue).saveToTranscript('ADMS_Pais_Web__c');

    const urlProcedencia = document.getElementById('urlProcedencia');
    urlProcedencia.value = window.location.href;
    liveagent.addCustomDetail('URL Procedencia', urlProcedencia.value).saveToTranscript('ADMS_URL_de_procedencia__c');
}

/** Initialize event listeners for chat elements
 */
function addEventListeners() {
    document.querySelector('.js-chat-button-online')
        .addEventListener('click', () => {
            setValues();
            liveagent.startChat(buttonID);
        });

    document.querySelector('.js-chat-button-offline')
        .addEventListener('click', () => {
            setValues();
            liveagent.startChat(buttonID);
        });
}

/** Initialize chat
 */
function init() {
    setGlobalVariables();

    window.onload = function () {
        if (typeof liveagent !== 'undefined') {
            liveagent.init(`${liveAgentHost}/chat`, chatDeploymentID, chatOrganizationID);
            liveagent.enableLogging();

            // Comprobar si hay agentes disponibles para mostrar un botón u otro
            /* eslint-disable no-underscore-dangle */
            if (!window._laq) { window._laq = []; }
            window._laq.push(function () {
                const onlineButton = document.querySelector('.js-chat-button-online');
                liveagent.showWhenOnline(buttonID, onlineButton);

                const offlineButton = document.querySelector('.js-chat-button-offline');
                liveagent.showWhenOffline(buttonID, offlineButton);

                const chatBubble = document.querySelector('.js-chat');
                chatBubble.classList.remove('d-none');
            });
            /* eslint-enable no-underscore-dangle */

            addEventListeners();
        }
    };
}

module.exports = {
    init: init
};
